import type { ArticleData } from '../entities/article';
import { ArticleManager } from '../manager';

const sortTopStoriesAndSponsoredWithAlgo = <T = ArticleData>(topStories: T[], sponsored: T[]): T[] => {
  const result: T[] = [];
  let firstIndex = 0;
  let secondIndex = 0;
  let counter = 0;

  while (firstIndex < topStories?.length || secondIndex < sponsored?.length) {
    if (counter % 4 === 3 && secondIndex < sponsored?.length) {
      result.push(sponsored[secondIndex]);
      secondIndex++;
    } else if (firstIndex < topStories?.length) {
      result.push(topStories[firstIndex]);
      firstIndex++;
    }
    counter++;
  }

  return result;
};

export const getInfiniteScrollArticles = async (
  articleManager: ArticleManager,
  articleData: ArticleData,
  //userId?: number | string,
): Promise<ArticleData[]> => {
  try {
    const { ok: relevantArticlesResponse } = await articleManager.getRelevantArticles(articleData);

    const nextArticles = [
      ...sortTopStoriesAndSponsoredWithAlgo(
        relevantArticlesResponse?.topStories ?? [],
        relevantArticlesResponse?.sponsored ?? [],
      ),
    ];

    return nextArticles;

    // if (Array.isArray(topArticlesResponse) && topArticlesResponse.length) {
    //   const nextArticles = [
    //     ...sortTopStoriesAndSponsoredWithAlgo(topArticlesResponse ?? [], relevantArticlesResponse?.sponsored ?? []),
    //   ];
    //   return nextArticles;
    // }
  } catch {
    return [];
  }
};

export const getInfiniteScrollArticlesIDs = async (
  articleManager: ArticleManager,
  articleData: ArticleData,
): Promise<number[]> => {
  try {
    const { ok: relevantArticlesResponse } = await articleManager.getRelevantArticlesIDs(articleData);

    const topStories = relevantArticlesResponse?.topStories ?? [];
    const sponsored = relevantArticlesResponse?.sponsored ?? [];

    return [...sortTopStoriesAndSponsoredWithAlgo<number>(topStories, sponsored)];
  } catch {
    return [];
  }
};
